








































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import LoadingIndicator from '@components/LoadingIndicator'
import ShoppingCartMiniItemCard from '@ui/cards/ShoppingCartMiniItemCard'
import UpdateQuantityTriggerModal from '@triggers/CheckoutWizard/UpdateQuantityTriggerModal'
import RemoveFromCartTriggerModal from '@triggers/CheckoutWizard/RemoveFromCartTriggerModal'
import ShoppingCartSummary from './ShoppingCartSummary'

settings =
  name: "ShoppingCart"
  components: { UpdateQuantityTriggerModal, RemoveFromCartTriggerModal, LoadingIndicator, ShoppingCartMiniItemCard, ShoppingCartSummary }
  resources:
    cart:
      resourceName: 'shopping_cart'
      slug: 'event_schedules/:schedule.id/shopping_cart'
      fetch: false

  vue:
    props: ['eventSchedule', 'brandRep']

    mounted: ->
      @fetch('cart') if @schedule
      @scrollCart()

    computed:
      schedule: -> @eventSchedule || @getAppSession('selectedEventSchedule')
      lineItems: -> @cart?.line_items || []
      selectedEventIds: -> @lineItems.map((item) => @eventForLineItem(item)?.id)

      lineItemsIsEmpty: -> !@resourceIsLoading(@cart) && !@lineItems.length

      lineItemsByEvent: ->
        events = {}
        for lineItem in @lineItems
          event = @eventForLineItem(lineItem)
          events[event.id] ||= []
          events[event.id].push lineItem
        Object.values(events)

    methods:
      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      scrollCart: ->
        cartscroll = document.getElementById('cartscroll')
        return unless cartscroll?
        cartscroll.scrollTop = cartscroll.scrollHeight

      thumbUrlForEvent: (event) -> event?.image?.thumb_url

      navigateToEventDetails: (event) -> @$router.push { name: 'EventFeedDetails', params: { eventId: event.id } }

      navigateToCheckoutPage: ->
        if @currentMemberIsSuperUser()
          @$router.push({ name: 'BrandRepShoppingCartPage', params: { brandRepId: @brandRep.id } })
        else
          @$router.push({ name: 'CheckoutPage' })

      hasOneSpace: (lineItem) -> lineItem.spaces.length is 1

      hiRemoveSpaceFromEvent: (spaceIndex, lineItem) ->
        lineItem.spaces = [...lineItem.spaces].filter((space, index) -> index != spaceIndex)
        @saveShoppingCart()

      updateQuantityTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateQuantityTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateQuantity: ->
        @fetch('cart')
        @$refs.updateQuantityTrigger.close()

      removeFromCartTrigger: (lineItem) ->
        payload =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.shoppingCartRemoveFromCartTrigger.fire(payload, modalOptions)
      onCartRemoveFromCart: ->
        @fetch('cart')
        @$refs.shoppingCartRemoveFromCartTrigger.close()

      spaceFor: (lineItem) -> @eventForLineItem(lineItem)?.spaces?[lineItem.space_name]

      spaceTypeFor: (lineItem) -> @spaceFor(lineItem)?.type
      spacePriceFor: (lineItem) -> @spaceFor(lineItem)?.supplier_price_in_cents / 100
      spaceIconFor: (lineItem) -> @iconForSpace(@spaceFor(lineItem))

    watch:
      lineItems: ->
        @$nextTick -> @scrollCart()

      schedule: ->
        @fetch('cart') if @schedule

export default VueOptions.vue settings
